import Vue from 'vue'

import VueI18n from 'vue-i18n'

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import en from './en'
import zh from './zh'
import ElementLocale from 'element-ui/lib/locale'

Vue.use(VueI18n)

const messages = {
  en: {
    ...en,
    ...enLocale,
  },
  'zh-CN': {
    ...zh,
    ...zhLocale,
  },
}
// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh-CN', // set locale
  messages, // set locale messages
})

ElementLocale.i18n((key, value) => i18n.t(key, value))
export default i18n
